import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';

@Pipe({
  name: 'removeUnknownLocation'
})
export class RemoveUnknownLocationPipe implements PipeTransform {

  transform(trains: MonitoredTrain[]): unknown {
    return trains && trains.filter(train => train.currentPosition && train.currentPosition.latitude && train.currentPosition.longitude );
  }

}
